import { Navigate, Route } from 'react-router-dom'
import { UserProfilePage } from '~/@biz_common/user-profile/UserProfilePage'
import { CallMePage } from '~/@biz_common/call-me/CallMePage'
import { ContactFormPage } from '~/@biz_common/contact-form/ContactFormPage'
import { FaqPage } from '~/@biz_common/faq/FaqPage'
import { HelpCenterPage } from '~/@biz_common/help-center/HelpCenterPage'
import { PortfolioPage } from '~/@biz_owner/portfolio/PortfolioPage'
import { WelcomeIntroPage } from '~/@biz_owner/welcome-intro/WelcomeIntroPage'
import { DocumentsInfoPage } from '~/@biz_flow_owner/document-info/DocumentsInfoPage'
import { DocumentsUploadPage } from '~/@biz_flow_owner/document-upload/DocumentsUploadPage'
import { OwnerFormPage } from '~/@biz_flow_owner/owner-form/OwnerFormPage'
import { PropertyAdressPage } from '~/@biz_flow_owner/property-adress/PropertyAdressPage'
import { PropertyDetailsPage } from '~/@biz_flow_owner/property-details/PropertyDetailsPage'
import { PropertyInformationsPage } from '~/@biz_flow_owner/property-informations/PropertyInformationsPage'
import { SecondRentPage } from '~/@biz_flow_owner/second-rent/SecondRentPage'
import { LoggedInGuard } from '~/@utils/auth-guard/LoggedInGuard'
import { DocumentsPage } from '~/@biz_common/documents/DocumentsPage'
import { ChangePhonePage } from '~/@biz_common/phone-change/ChangePhonePage'
import { ChangePhoneCodePage } from '~/@biz_common/phone-change/ChangePhoneCodePage'

export const OwnerRoutes = () => {
  return (
    <>
      <Route path="intro" element={<WelcomeIntroPage />} />

      <Route element={<LoggedInGuard />}>
        <Route
          path="portfolio"
          element={<Navigate to="/vlastnik/portfolio/overview" replace />}
        />
        <Route path="portfolio/:selectedTab?" element={<PortfolioPage />} />
        <Route path="faq" element={<FaqPage />} />
        <Route path="user-profile" element={<UserProfilePage />} />
        <Route path="user-profile/documents" element={<DocumentsPage />} />
        <Route path="user-profile/change-phone" element={<ChangePhonePage />} />
        <Route
          path="user-profile/change-phone/code"
          element={<ChangePhoneCodePage />}
        />

        <Route
          path="dotaznik/informacie-o-ziadatelovi"
          element={<OwnerFormPage />}
        />
        <Route
          path="dotaznik/adresa-nehnutelnosti"
          element={<PropertyAdressPage />}
        />
        <Route
          path="dotaznik/informacie-o-nehnutelnosti/:estateId?"
          element={<PropertyInformationsPage />}
        />
        <Route
          path="dotaznik/detaily-o-nehnutelnosti/:estateId?"
          element={<PropertyDetailsPage />}
        />
        <Route
          path="dotaznik/mesacny-dochodok/:estateId?"
          element={<SecondRentPage />}
        />
        <Route
          path="dotaznik/potrebne-dokumenty/:orderId?"
          element={<DocumentsInfoPage />}
        />
        <Route
          path="dotaznik/nahravanie-dokumentov/:orderId?"
          element={<DocumentsUploadPage />}
        />

        <Route path="help-center" element={<HelpCenterPage />} />
        <Route path="help-center/call-me" element={<CallMePage />} />
        <Route path="help-center/contact-form" element={<ContactFormPage />} />
      </Route>
    </>
  )
}
